import { render, staticRenderFns } from "./k-field-code.vue?vue&type=template&id=9bf7d062"
import script from "./k-field-code.vue?vue&type=script&lang=js"
export * from "./k-field-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports